import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as moment from 'moment';

export class DefaultValueSettings {
    BoolDefault = false;
    DateDefault = new Date(1900, 0, 1);
    TextDefault = '#';
    FloatDefault = 0;
    IntegralDefault = 0;

    getDefaultObject() {
        return {
            'System.DateTime': moment(this.DateDefault).format('L'),
            'System.String': this.TextDefault,
            'System.Char': this.TextDefault,
            'System.Int16': '' + this.IntegralDefault,
            'System.Int32': '' + this.IntegralDefault,
            'System.Int64': '' + this.IntegralDefault,
            'System.Decimal': '' + this.FloatDefault,
            'System.Double': '' + this.FloatDefault,
            'System.Single': '' + this.FloatDefault,
            'System.Boolean': '' + this.BoolDefault
        };
    }
}

@Component({
    selector: 'default-definition-control',
    templateUrl: './default.definition.control.html'
})
export class DefaultDefinitionControl {
    //#region Data
    DataValue: DefaultValueSettings;

    @Input()
    get Data() {
        return this.DataValue;
    }
    set Data(val) {
        this.DataValue = val;
        this.DataChange.emit(this.DataValue);
    }

    @Output() DataChange = new EventEmitter<DefaultValueSettings>();
    //#endregion

    //#region Icon
    IconValue = 'edit';

    @Input()
    get Icon() {
        return this.IconValue;
    }
    set Icon(val) {
        if (val) {
            this.IconValue = val;
            this.IconChange.emit(this.IconValue);
        }
    }

    @Output() IconChange = new EventEmitter<string>();
    //#endregion

    @Output() DefaultChanged = new EventEmitter<void>();

    onOpen() {
        if (!this.DataValue) {
            this.Data = new DefaultValueSettings();
        }
    }

    onClose() {
        this.DefaultChanged.emit();
    }

    onClear() {
        this.Data = null;
        this.DefaultChanged.emit();
    }
}
